import { FC } from 'react'
import cx from 'classnames'
import { useTheme } from 'styled-components'

import { ActionButtonProps } from '../ActionButton'
import { ActionButtonVariant } from '../ActionButton/styled'
import { LinkProps } from '../Link'

import * as SC from './styled'

export type BannerBlockLeftRightProps = {
  className?: string
  title?: string
  blockLeft: {
    title?: string
    subtitle?: string
    text?: string
    ecpsConnectionButton: ActionButtonProps
    mailConnectionButton: ActionButtonProps
    ecpsConnectionIssueLink: LinkProps
  }
  blockRight: {
    title?: string
    subtitle?: string
    button: ActionButtonProps
  }
  backButton?: LinkProps
}

const BannerBlockLeftRight: FC<BannerBlockLeftRightProps> = ({
  className,
  title,
  blockLeft,
  blockRight,
  backButton,
}) => {
  const theme = useTheme()
  return (
    <SC.Banner className={cx('BannerBlockLeftRight', className)}>
      {title && <SC.Title $centered>{title}</SC.Title>}
      <SC.Flex>
        <SC.Block>
          <SC.Content>
            <SC.Title>{blockLeft.title}</SC.Title>
            <SC.SubTitle>{blockLeft.subtitle}</SC.SubTitle>
            <SC.ButtonsWrapper>
              <SC.Button
                variant={ActionButtonVariant.quaternary}
                {...blockLeft.ecpsConnectionButton}
              />
              <SC.Button
                variant={ActionButtonVariant.primary}
                {...blockLeft.mailConnectionButton}
              />
            </SC.ButtonsWrapper>
            <SC.Description>{blockLeft.text}</SC.Description>
            <SC.EcpsConnectionIssueLink
              {...blockLeft.ecpsConnectionIssueLink}
            />
          </SC.Content>
        </SC.Block>
        <SC.Block>
          <SC.Content>
            <SC.Title>{blockRight.title}</SC.Title>
            <SC.SubTitle>{blockRight.subtitle}</SC.SubTitle>
            <SC.LeftBlockButton
              variant={ActionButtonVariant.primary}
              {...blockRight.button}
            />
          </SC.Content>
        </SC.Block>
      </SC.Flex>
      {backButton && (
        <SC._Link {...backButton}>
          <SC.BackLinkIcon
            icon="chevronLeft"
            height={14}
            color={theme.colors.pureWhite}
          />
          {backButton.text}
        </SC._Link>
      )}
    </SC.Banner>
  )
}

export default BannerBlockLeftRight
